import wixLocation from 'wix-location';
import wixWindow from 'wix-window'; 
$w.onReady(function () { 
if (wixWindow.formFactor === "Mobile"){
let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#heb1').expand();
     $w('#heb12').expand();
	 $w('#hebblog').expand();
     $w('#eng1').collapse();
     $w('#eng12').collapse();
	 $w('#engblog').collapse();
	 $w('#hebfooter').expand();
     $w('#engfooter').collapse();
} else { 
     $w('#heb1').collapse();
      $w('#heb12').collapse();
	 $w('#hebblog').collapse();
     $w('#eng1').expand();
     $w('#eng12').expand();
	 $w('#engblog').expand();
	 $w('#hebfooter').collapse();
     $w('#engfooter').expand();
   }
} else {
	let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#heb1').expand();
     $w('#heb12').expand();
	 $w('#hebblog').expand();
     $w('#eng1').collapse();
     $w('#eng12').collapse();
	 $w('#engblog').collapse();
	 $w('#hebfooter').expand();
     $w('#engfooter').collapse();
} else { 
     $w('#heb1').collapse();
     $w('#heb12').collapse();
	 $w('#hebblog').collapse();
     $w('#eng1').expand();
     $w('#eng12').expand();
	 $w('#engblog').expand();
	 $w('#hebfooter').collapse();
     $w('#engfooter').expand();
}
}
});